module.exports = "//a.spikex.com/sigma/frontend-ssr-web-trade/_next/static/images/suspended-light-5095c1375a50025166ef03c8c28d6144.png";